const loadEcharts = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  if (!window.echarts) {
    const $ = window.layui?.jquery || window.jQuery || window.$;
    if ($ && $.ajax) {
      $.ajax({
        url: '/static/common/layui/components/echarts/echarts.min.js',
        dataType: 'script',
        cache: true,
        async: false,
      });
    }
  }
  return window.echarts;
};

const echarts = loadEcharts();

export { echarts };
